import { Service } from '@hems/service/src/api/Service';
import { apiWrapper } from '@hems/service/src/util/apiHelper';
import { Helper } from '@hems/util';
export default class DeviceService extends Service {
    constructor(axios) {
        super(axios);
    }
    /** Site 이미지 조회 */
    getImageBySiteId = async (siteId) => {
        return await this.get(apiWrapper.managerApi(`/devices/profiles/${siteId}/images`), {}, {
            responseType: 'blob',
        });
    };
    /** Site 이미지 저장 */
    saveImageBySiteId = async (siteId, params) => {
        const { data } = await this.put(apiWrapper.managerApi(`/devices/profiles/${siteId}/images`), params, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
        return data;
    };
    /** AC System - 모니터링 Site 목록 조회 */
    getMonitoringSiteList = async (params) => {
        const { data } = await this.get(apiWrapper.stateApi('/devices/telemetries/multi-inverter/sites'), params);
        return data;
    };
    /**  AC System - 모니터링 EMS 목록 조회 */
    getMonitoringDeviceList = async (params) => {
        const { data } = await this.get(apiWrapper.stateApi('/devices/telemetries/multi-inverter/devices'), params);
        return data;
    };
    /** 모니터링 상세 - Dashboard - 프로파일, Inventory */
    getDeviceProfile = async (siteId) => {
        const { data } = await this.get(apiWrapper.managerApi(`/devices/telemetries/${siteId}`));
        return data;
    };
    /** 모니터링 상세 - System Settings - Installation */
    getInstallationInfo = async (siteId) => {
        const { data } = await this.get(apiWrapper.managerApi(`/devices/profiles/${siteId}/installations`));
        return data;
    };
    /**  Array & Mapping - Basic Device Info */
    getBasicDeviceInfo = async (siteId) => {
        const { data } = await this.get(apiWrapper.managerApi(`/resources/sites/${siteId}/devices`));
        return data;
    };
    /** 에러 모듈 목록 */
    getErrorDeviceList = async (siteId) => {
        const { data } = await this.get(apiWrapper.managerApi(`/devices/alarms/${siteId}/modules`));
        return data;
    };
    /** 장비 목록 엑셀 다운로드 */
    getDeviceList = async () => {
        const { data } = await this.get(apiWrapper.managerApi('/devices/profiles/excel-files'));
        return data;
    };
    /** 그리드 코드 정보 조회 */
    getGridCodeInfo = async (params) => {
        const { data } = await this.get(apiWrapper.managerApi('/devices/profiles/grid-codes'), params);
        return data;
    };
    /** Site 위치 정보 저장 */
    saveLocationInfo = async (siteId, params) => {
        const { data } = await this.put(apiWrapper.managerApi(`/devices/profiles/${siteId}/locations`), params);
        return data;
    };
    /** Site Home Owner 정보 저장 */
    saveHomeownerInfo = async (siteId, params) => {
        const { data } = await this.put(apiWrapper.managerApi(`/devices/profiles/${siteId}/homeowners`), params);
        return data;
    };
    /** Site Off Grid 여부 저장 */
    updateOffGrid = async (siteId, params) => {
        const { data } = await this.put(apiWrapper.managerApi(`/devices/profiles/${siteId}/off-grids`), params);
        return data;
    };
    /** Site 위치 중복 체크 */
    checkDuplicatedLocation = async (params) => {
        const { data } = await this.get(apiWrapper.managerApi('/devices/profiles/locations/validations'), params);
        return data;
    };
    /** Site 메모 저장 */
    updateComments = async (siteId, params) => {
        const { data } = await this.put(apiWrapper.managerApi(`/devices/profiles/${siteId}/comments`), params);
        return data;
    };
    /** Site 설치 Step 조회 */
    getInstallationSteps = async (siteId) => {
        return await this.get(apiWrapper.managerApi(`/managements/mobiles/pro-apps/${siteId}/steps`)).then((res) => {
            const data = res.data;
            return {
                ...data,
                stepData: data?.stepData ? (Helper.isJSON(data.stepData) ? JSON.parse(data.stepData) : null) : null,
            };
        });
    };
    /** Site 네트워크 타입 조회 */
    getSiteNetworkType = async (siteId) => {
        const { data } = await this.get(apiWrapper.stateApi(`/devices/telemetries/network-type/${siteId}`));
        return data;
    };
    /** Site 부가 정보(siteType, displayMapperFlag) 조회 */
    getSite = async (siteId) => {
        const { data } = await this.get(apiWrapper.managerApiV1(`/sites/${siteId}`));
        return data;
    };
    /** Site 정보(siteType, displayMapperFlag, installerId) 변경 */
    updateSite = async (siteId, params) => this.patchNew(apiWrapper.managerApiV1(`/sites/${siteId}`), params);
    /** Grid Profile Report API (pdf data). 응답: { context: {}, data: GridProfileData } */
    getSiteGridProfile = async (siteId, customGridProfile) => this.get(apiWrapper.managerApiV1(`/sites/${siteId}/grid-profile`), {
        customGridProfile,
    });
    /** Basic, Engineer, Advanced Setting 조회 */
    getConfiguration = async (deviceId) => {
        const { data } = await this.get(apiWrapper.managerApiV1(`/devices/${deviceId}/configuration-state`));
        return data;
    };
    /** Basic, Engineer, Advanced Setting 저장 */
    saveConfiguration = (deviceId, requestBody) => this.postNew(apiWrapper.managerApiV1(`/devices/${deviceId}/configuration`), requestBody);
    /** Cloud Passkey 조회 */
    getCloudPasskey = async (deviceId) => {
        const { data } = await this.get(apiWrapper.managerApiV1(`/devices/${deviceId}/password`));
        return data;
    };
}
export { DeviceService };
